import { render, staticRenderFns } from "./ResourceSituation.vue?vue&type=template&id=b0269c08&scoped=true&"
import script from "./ResourceSituation.vue?vue&type=script&lang=js&"
export * from "./ResourceSituation.vue?vue&type=script&lang=js&"
import style0 from "./ResourceSituation.vue?vue&type=style&index=0&id=b0269c08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0269c08",
  null
  
)

export default component.exports